import { Component } from '@angular/core';

@Component({
  selector: 'qas-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  version: string = config.VERSION;
  displayVersion: string = config.DISPLAY_VERSION;
  year: number = new Date().getFullYear();
}
